import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from '../hooks/useForm';
import profesionService from '../services/profesionService';
import '../styles/Professions.css';
import '../styles/theme/toast.css';

const CreateProfession = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showToast, setShowToast] = useState(false);

  const validateProfessionForm = (formData) => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'El nombre de la profesión es requerido';
    } else if (formData.name.length < 3) {
      newErrors.name = 'El nombre debe tener al menos 3 caracteres';
    }
    
    if (!formData.description.trim()) {
      newErrors.description = 'La descripción es requerida';
    } else if (formData.description.length < 10) {
      newErrors.description = 'La descripción debe tener al menos 10 caracteres';
    }

    return newErrors;
  };

  const { formData, errors, handleInputChange, validateForm } = useForm({
    name: '',
    description: ''
  }, validateProfessionForm);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        setLoading(true);
        setError('');
        
        const profesionData = {
          PROFESION_NOMBRE: formData.name.trim(),
          PROFESION_OBSERVACION: formData.description.trim()
        };
        
        await profesionService.createProfesion(profesionData);
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
        setTimeout(() => navigate('/professions'), 1200);
        
      } catch (error) {
        console.error('Error al crear profesión:', error);
        setError('Error al crear profesión: ' + error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleCancel = () => {
    navigate('/professions');
  };

  return (
    <>
      {showToast && (
        <div className="custom-toast custom-toast-success">
          ¡Profesión registrada exitosamente!
        </div>
      )}
      <div className="create-profession-container">
        <div className="header-section">
          <h2>Crear Nueva Profesión</h2>
        </div>

        {error && (
          <div className="error-message">
            <i className="fas fa-exclamation-triangle"></i> {error}
          </div>
        )}
        
        <form className="profession-form" onSubmit={handleSubmit}>
          <div className="form-section">
            <h3>Información de la Profesión</h3>
            
            <div className="form-group">
              <label htmlFor="name">
                Nombre de la Profesión <span className="required">*</span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                className={errors.name ? 'error' : ''}
                placeholder="Ej: Médico General"
                disabled={loading}
              />
              {errors.name && <span className="error-message">{errors.name}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="description">
                Descripción <span className="required">*</span>
              </label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                className={errors.description ? 'error' : ''}
                placeholder="Describe las funciones..."
                rows="4"
                disabled={loading}
              />
              {errors.description && <span className="error-message">{errors.description}</span>}
            </div>
          </div>

          <div className="form-actions">
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i> Creando...
                </>
              ) : (
                'Crear Profesión'
              )}
            </button>
            <button type="button" className="btn-secondary" onClick={handleCancel} disabled={loading}>
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default CreateProfession;